import createSubmit from '../../Form/createSubmitButton.jsx'
import { name } from './UserForm.jsx'

export default createSubmit(name)